const SessionControllerButton = ({
  children,
  isEnabled,
  onClick,
  title,
}: {
  children: React.ReactNode;
  isEnabled: boolean;
  onClick: () => void;
  title: string;
}) => {
  // rendering session controller button component here
  return (
    <button
      title={title}
      type='button'
      onClick={onClick}
      className={`flex items-center justify-center text-base-white size-[50px] md:size-[60px] xl:size-[70px] rounded-full hover:scale-110 active:scale-95 duration-300 ${
        isEnabled ? 'bg-base-purple' : 'bg-base-red'
      }`}
    >
      {children}
    </button>
  );
};

export default SessionControllerButton;
